var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDot2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325,
    height: 263,
    viewBox: "0 0 325 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M325 261.463C249.421 261.463 176.111 235.633 117.224 188.257C58.3365 140.88 17.4087 74.8013 1.2252 0.974874",
    stroke: "white",
    strokeWidth: 1.07443,
    strokeDasharray: "8.6 8.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot2);
export default __webpack_public_path__ + "static/media/dot2.4d865ef7679c485172a2d4475889a22d.svg";
export { ForwardRef as ReactComponent };